import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';

export default defineModule({
    name: 'core',
    routes: [
        {
            path: '/core',
            name: 'core',
            component: () => import('#modules/core/pages/index.vue'),
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
        },
    ],
});
